import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { modals } from '@/mixins/modal';

export default Vue.component('link-group', {
  template: require('./template.html'),
  name: 'link-group',
  props: [
    'droplet',
    'show-edit-bubble',
    'group-item',
    'droplet-key',
  ],
  mixins: [modals],
  computed: {
    ...mapGetters(['currentSite']),
    groupList() {
      // we grab all groups from each dynamic site types
      let groups = [];
      const dynamic = this.currentSite.dynamic || {};
      _.forOwn(dynamic, (value, siteType) => {
        const typeGroups = _.cloneDeep(value.groups || []);
        groups = groups.concat(typeGroups.map((g) => {
          g.dataType = siteType;
          return g;
        }));
      });
      const sortOn = this.sortKey || this.cols[3];
      return _.chain(groups)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                const e = [];
                // only grab the properties that the table uses
                _.filter(row, () => {
                  _.forEach(this.cols, (c) => {
                    // clean up the values so that the
                    // searchable items are like how
                    // the template is written
                    const col = this.cleanItem(row[c], c);
                    e.push(col);
                  });
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line
          return (a === b ? 0 : a < b ? -1 : 1) * ascDesc; // eslint-disable-line
        })
        .value();
    },
  },
  watch: {
    groupModal(open) {
      if (open) {
        this.activeGroup = null;
        this.confirmReplace = false;
      }
    },
  },
  data() {
    return {
      cols: ['thumbnail', 'alias', 'dataType', 'created'],
      sortMap: {},
      paginate: ['groupList'],
      groupModal: false,
      filterKey: '',
      sortKey: '',
      activeGroup: null,
      confirmReplace: false,
      confirmUnlink: false,
    };
  },
  created() {
    this.sortMap = _.zipObject(this.cols, _.fill(Array(this.cols.length), -1));
  },
  methods: {
    linkGroup() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: this.dropletKey,
        val: this.activeGroup._id,
      });
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'siteType',
        val: this.activeGroup.dataType,
      });
      this.activeGroup = null;
      this.confirmReplace = false;
      this.openGroups();
    },
    unlinkGroup() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: this.dropletKey,
        val: null,
      });
      this.confirmUnlink = false;
    },
    openGroups() {
      this.groupModal = !this.groupModal;
      const content = this.$refs.groupModal;
      if (this.groupModal) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
    confirmLink(item) {
      this.activeGroup = item;
      this.confirmReplace = true;
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    seperateCamalCase(str, mobile) {
      const tail = mobile ? ': ' : '';
      return str.replace(/([A-Z])/g, g => ` ${g[0].toLowerCase()}`) + tail;
    },
    highlight(ctx, query, col, it) {
      const c = this.cleanItem(ctx, col, it);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    cleanHeader(text) {
      return _.startCase(text);
    },
    cleanItem(item, col) {
      let i = item || '--';
      if (col === 'created' && i !== '--') {
        i = this._zoneFormat({
          date: i,
          format: 'MM-DD-YYYY hh:mm A z',
          zone: this.currentSite.timezone,
        });
      }
      return i;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/_bubble-options/components/link-group/index.js